<template>
  <div :id="item.fields.id"></div>
  <Suspense>
    <TagOverviewSectionContent :item="item" />
    <template #fallback>
      <LazyContentfulSkeletonsTagOverviewSectionSkeleton
        :show-search-bar="item.fields.showSearchBar"
        :show-tag-list="item.fields.showTagList"
      />
    </template>
  </Suspense>
</template>

<script setup lang="ts">
import type { ITagOverviewSection } from '~~/lib/ContentfulService';
import TagOverviewSectionContent from '~/components/global/contentful/TagOverviewSectionContent.vue';

interface Props {
  item: ITagOverviewSection;
}

defineProps<Props>();
</script>
